import { RootState } from "@app/redux/root-reducer";

export const selectAllCategoryDataState = (store: RootState) =>
  store.allCategoryReducer.category;
export const selectParentCategoryDataState = (store: RootState) =>
  store.allCategoryReducer.getParentCategory;
export const selectAddCategoryState = (store: RootState) =>
  store.allCategoryReducer.addCategory;
export const selectUpdateCategoryState = (store: RootState) =>
  store.allCategoryReducer.updateCategory;
export const selectDeleteCategoryState = (store: RootState) =>
  store.allCategoryReducer.deleteCategory;
